import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJoin = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 4.5,
		cy: 6,
		r: 3,
		stroke: "black"
	}), /* @__PURE__ */ _jsx("circle", {
		cx: 7.5,
		cy: 6,
		r: 3,
		stroke: "black"
	})]
});
export default SvgJoin;
